import { useEffect } from 'react';

const useWindowEvent = (event, callback) => {
  useEffect(() => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }, [event, callback]);
};

export const useGlobalBeforeUnload = callback => {
  return useWindowEvent('beforeunload', callback);
};

export const useGlobalUnload = callback => {
  return useWindowEvent('unload', callback);
};
